export default "__VITE_ASSET__a8c7a395__"